import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const InBetweenIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox={`0 0 15 6`} stroke="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 2.75C13.3333 2.05964 12.7736 1.5 12.0833 1.5C11.3929 1.5 10.8333 2.05964 10.8333 2.75C10.8333 3.44036 11.3929 4 12.0833 4C12.7736 4 13.3333 3.44036 13.3333 2.75ZM12.0833 -1.20206e-07C13.602 -5.38182e-08 14.8333 1.23122 14.8333 2.75C14.8333 4.26878 13.602 5.5 12.0833 5.5C10.8245 5.5 9.76323 4.65425 9.43677 3.5L5.3964 3.5C5.06994 4.65425 4.0087 5.5 2.74992 5.5C1.23114 5.5 -8.12489e-05 4.26878 -8.11825e-05 2.75C-8.11161e-05 1.23122 1.23114 -5.94567e-07 2.74992 -5.28179e-07C4.0087 -4.73156e-07 5.06994 0.845747 5.3964 2L9.43677 2C9.76323 0.845747 10.8245 -1.75229e-07 12.0833 -1.20206e-07ZM2.74992 1.5C3.44028 1.5 3.99992 2.05964 3.99992 2.75C3.99992 3.44036 3.44028 4 2.74992 4C2.05956 4 1.49992 3.44036 1.49992 2.75C1.49992 2.05964 2.05956 1.5 2.74992 1.5Z"
      />
    </BaseSVG>
  )
}
